// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--zK1B0","hist":"hist--OVVwi"};